<template>
  <div class="tourism-button-create" @click="create">
    観光ポイントの作成
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [ MixinResultHandler ],
  methods: {
    create: async function () {
      const result = await this.$store.dispatch(
        'tourism/saveTourism',
        'new'
      )
      this.showSnackAndMove(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.tourism-button-create {
  @include button-ol-success;
}
</style>
